import React from 'react';
import './TodoCounter.css';
import { TodoContext } from '../TodoContext';

function TodoCounter(){

    const {totalTodos, completedTodos} = React.useContext(TodoContext);
    
    return(
        <h1 className='TodoCounter'>You have finished {completedTodos} tasks of {totalTodos}</h1>
        );
}

export {TodoCounter};